import React from 'react';
import './MobileNotSupported.css';

/**
 * Full-screen page shown to mobile users when they try to access
 * any route other than /login. Encourages them to use a desktop browser.
 */
const MobileNotSupported = () => {
    return (
        <div className="mobile-not-supported">
            <div className="mobile-not-supported__card">
                <img
                    src="/textOnlyLogoOrr-01.png"
                    alt="Alchemiq Logo"
                    className="mobile-not-supported__logo"
                />

                <div className="mobile-not-supported__icon">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="5" y="1" width="14" height="22" rx="2" stroke="#94a3b8" strokeWidth="1.5" fill="none" />
                        <line x1="9" y1="4" x2="15" y2="4" stroke="#94a3b8" strokeWidth="1.5" strokeLinecap="round" />
                        <circle cx="12" cy="19" r="1" fill="#94a3b8" />
                        {/* Diagonal "not supported" slash */}
                        <line x1="3" y1="21" x2="21" y2="3" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>

                <h1 className="mobile-not-supported__title">
                    Desktop Only
                </h1>

                <p className="mobile-not-supported__message">
                    Alchemiq is optimized for desktop browsers.
                    Please open this page on a laptop or desktop computer for the best experience.
                </p>

                <div className="mobile-not-supported__url-hint">
                    <span className="mobile-not-supported__url-label">Visit on desktop:</span>
                    <code className="mobile-not-supported__url">app.alchemiqai.com</code>
                </div>
            </div>
        </div>
    );
};

export default MobileNotSupported;
